<template>
  <div class="table-container">
    <table class="m-flex" aria-label="provider biography">
      <tbody>
        <tr class="nurse-edit" :id="'nurse-edit'+nurseLList.licensenum">
        <div :id="'nurseform'+nurseLList.licensenum">
            <label for="nursefname">First Name:</label>
            <input type="text" id="nursefname" placeholder="*Required" :value="nurseLList.firstname" class="field"/>
            <label for="nurselname">Last Name:</label>
            <input type="text" id="nurselname" :value="nurseLList.lastname" placeholder="*Required" class="field"/>
            <label for="nraccount">Account Number:</label>
            <input type="text" id="nraccount" :value="nurseLList.acountnumber" placeholder="*Required" class="field"/>
            <label for="nursetype">Nurse Type:</label>
            <select class="field" id="nursetype" aria-placeholder="*Required">
                <option v-if="nurseLList.licensetype" select="selected" :value="nurseLList.licensetype">Registred Nurse</option>
                <option v-else-if="!nurseLList.licensetype" select="selected" value="selected">Select Nurse Type</option>
                <option value="RN">Registred Nurse</option>
                <option value="LPN">Licensed Practical Nurse</option>
                <option value="CN">Cardic Nurse</option>
                <option value="CRNA">Certified Registered Nurse Anesthetist</option>
            </select>
            <label for="nraddress">Address:</label>
            <input type="text" id="nraddress" :value="nurseLList.addr1" class="field"/>
            <label for="nrcity">City:</label>
            <input type="text" id="nrcity" :value="nurseLList.city" class="field"/>
            <label for="nrstate">State:</label>
            <input type="text" id="nrstate" :value="nurseLList.state" class="field"/>
            <label for="nrzip">Zip:</label>
            <input type="text" id="nrzip" :value="nurseLList.zip" class="field"/>        
            <label for="nrlicense">License Number:</label>
            <input  type="text" id="nrlicense" :value="nurseLList.licensenum" placeholder="*Required" class="field"/>  
            <label for="nrdob">Date of Birth:</label>
            <input type="date" id="nrdob" :value="nurseLList.dob" placeholder="*Required" class="field"/>  
            <label v-if="nurseLList.primaryphone" for="primephone">Primary Phone:</label>
            <input v-if="nurseLList.primaryphone" type="phone" id="primephone" :value=" nurseLList.primaryphone"  class="field"/>
            <label v-if="nurseLList.secondaryphone" for="secphone">Secondary Phone:</label>
            <input v-if="nurseLList.secondarphone" type="phone" id="secphone" :value="nurseLList.secondaryphone"  class="field"/>  
            <label v-if="nurseLList.socialnum" for="nrsocial">Social Security:</label>
            <input v-if="nurseLList.socialnum" type="text" id="nrsocial" :value="nurseLList.socialnum" placeholder="*Required" class="field"/> 
            <label v-if="nurseLList.ncsbnid" for="nrnsbid">NBSID Number:</label>
            <input v-if="nurseLList.ncsbnid" type="text" id="nrnsbid" :value="nurseLList.ncsbnid" class="field"/>
            <label for="nurseemail">Email:</label>
            <input type="email" id="nurseemail" :value="nurseLList.email" placeholder="*Required" class="field"/><br><br>
            <div  class="btn-sec">
            <input type="button" class="btn btn-primary" value="Updte Nurse" id="updatenursebtn" @click="UpdateNurse($event,nurseLList.licensenum)"/>  
            <input type="button" class="btn btn-secondary" value="Close" id="cancelnursebtn" @click="CancelUpdateNurse($event,nurseLList.licensenum)"/>          
            </div>     
        </div>
        </tr>
        <tr class="nurse-card">
            <div class="card-title">{{nurseLList.firstname}} {{ nurseLList.lastname }}</div>
            <div class="card-controls">
                <div id="control-close"><span @click="EmitNurseCard">X</span></div>
                <div id="control-elipse">
                   <div class="elipse select"><span>....</span>
                      <ul>
                        <li class="elipse-dropdown">Assign Patient</li>
                      </ul>
                   </div>
                    
                </div>
            </div>
            <div :id="'nursecard'+nurseLList.licensenum">
                <tr>
                    <td class="m-align" rowspan="60" width="20%">
                    <img src="@/assets/images/avatar-female.jpg" class="provider__avatar"/>
                    
                    </td>
                </tr>
                <tr v-if="nurseLList.acountnumber">
                    <td class="provider__info capitalize">
                    <font-awesome-icon :icon="['fas', 'arrow-right']" class="icon"/>
                    <b>Account Number:</b><span :id="'accountnum'+nurseLList.licensenum">{{ nurseLList.acountnumber }}</span>
                    </td>
                </tr>
                <tr v-if="nurseLList.licensetype">
                    <td class="provider__info capitalize">
                    <font-awesome-icon :icon="['fas', 'arrow-right']" class="icon"/>
                    <b>License Type:</b><span :id="'ltype'+nurseLList.licensenum">{{ nurseLList.licensetype }}</span>
                    </td>
                </tr>
                <tr>
                    <td class="provider__info capitalize">
                    <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon"/>
                    <span v-if="nurseLList.addr1"> <b> Address:</b> {{ nurseLList.addr1.toLowerCase() }}</span>
                    <span v-else style="color: tomato">please pull the backend</span>
                    <span v-if="nurseLList.addr2"> , {{ nurseLList.addr2.toLowerCase() }}</span>
                    <span v-if="nurseLList.city"> , {{ nurseLList.city.toLowerCase() }}</span>
                    <span v-if="nurseLList.state"> , {{ nurseLList.state.toUpperCase() }}</span>
                    <span v-if="nurseLList.zip"> , {{ nurseLList.zip }}</span>
                    </td>
                </tr>
                <tr v-if="nurseLList.licensenum">
                    <td class="provider__info">
                    <!---<font-awesome-icon icon="phone" :id="'desktopTel'+patient.id" class="icon"/><b>Tel: </b><a href="#call" @click="CallProvider(provider)">{{ provider.tel }}</a>-->
                    <font-awesome-icon :icon="['fas', 'phone']"  class="icon"/><b>License Number:</b><a href="#verfiy" :id="'desktopLicense'+nurseLList.licensenum" @click="VerifyNurse(nurseLList.licensenum)">{{ nurseLList.licensenum }}</a>
                    </td>
                </tr>
                <tr v-if="nurseLList.licenseexpdate">
                    <td class="provider__info">
                    <!---<font-awesome-icon icon="phone" :id="'desktopTel'+patient.id" class="icon"/><b>Tel: </b><a href="#call" @click="CallProvider(provider)">{{ provider.tel }}</a>-->
                    <font-awesome-icon :icon="['fas', 'phone']" :id="'dob'+nurseLList.licensenum" class="icon"/><b>Expiration Date:</b><span>{{ nurseLList.licenseexpdate }}</span>
                    </td>
                </tr>
                <tr v-if="nurseLList.state">
                    <td class="provider__info">
                    <font-awesome-icon :icon="['fas', 'address-book']" class="icon"/>
                    <b>jurisdiction:</b> <span :id="'state'+nurseLList.licensenum">{{ nurseLList.state }}</span>
                    </td>
                </tr>
                <tr v-if="nurseLList.primaryphone">
                    <td class="provider__info">
                    <font-awesome-icon :icon="['fas', 'phone']" class="icon"/><b>Cell: </b><a :id='patient.id' href="#callProvCell" @click="CallProviderCell($event,nurseLList.providerid)">{{nurseLList.primaryphone }}</a>
                    </td>
                    <td class="d-option" :id="'d-option'+nurseLList.providerid">
                    <div class="option-container">
                        <div class="x-close"><a href="#closeoption" @click="closeDOption($event)" id="d-itemclose">X</a></div>
                        <div v-if="nurseLList.primaryphone" class="option-item" id="option-item1">
                        <h4>SMS or Call Provider Cell</h4>
                        <span class="slabel">Call:</span> <a href="#callprov" @click="callProvider(nurseLList)">{{ nurseLList.primaryphone }}</a><br/><br>
                        <span class="slabel">Text:</span> <a href="#smsprov" @click="showTextProv($event,nurseLList.primaryphone,patient.id,nurseLList.providerid)">{{ nurseLList.primaryphone }}</a><br/>
                        </div>
                    </div>
                    </td>
                    <td class="m-option" :id="'m-option'+nurseLList.providerid">
                    <div class="option-container">
                        <div class="x-close"><a href="#closeoption" @click="closeOption($event)" id="m-itemclose">X</a></div>
                        <div v-if="nurseLList.primaryphone" class="option-item" id="option-item1">
                        <h4>Call Nurse Primary</h4>
                        <a :href="'tel:'+nurseLList.cell">{{ nurseLList.primaryphone }}</a>
                        </div>
                        <div v-if="nurseLList.cell" class="option-item" id="option-item1">
                        <h4>Text or Call Provider</h4>
                        <a :href="'tel:'+nurseLList.primaryphone">{{ nurseLList.primaryphone }}</a>
                        <a :href="'sms:'+nurseLList.primaryphone">{{ nurseLList.primaryphone }}</a>
                        </div>
                    </div>
                    </td>
                </tr>
                <tr v-if="nurseLList.activestatus">
                    <td class="provider__info">
                    <font-awesome-icon :icon="['fas', 'fax']" class="icon"/>
                    <b>Active Status:</b> {{ nurseLList.activestatus }}
                    </td>
                </tr>
                <tr v-if="nurseLList.checkstatus">
                    <td class="provider__info">
                    <font-awesome-icon :icon="['fas', 'fax']" class="icon"/>
                    <b>Check Status Date:</b> {{ nurseLList.checkstatus }}
                    </td>
                </tr>
                <tr v-if="nurseLList.email">
                    <td class="provider__info capitalize">
                    <font-awesome-icon :icon="['fas', 'inbox']" class="icon"/>
                    <span><b>Email:</b><a href="#email" @click="showEmailModule($event,nurseLList,nurseLList.providerid)">{{ nurseLList.email }}</a></span>
                    </td>
                </tr>
            </div>
        </tr>
        </tbody>
    </table>
  </div>
</template>

<script>

  import $ from "jquery";
  import { licenceJurisdiction, enrolmentJurisdiction } from "@/utils/nurseCardJurisdiction";
  import { CURR_API, OTHER_API } from "@/constants/apis";
  import {
    classifyLookup,
    isLicenceInGoodStanding,
    isLicenceReinstated,
    lookupFailureMessage,
    FOUND,
    UNAVAILABLE,
  } from "@/api/nursysApi";
  import axios from "axios";
  import { mapGetters } from "vuex";
  export default {
    name: "GridNurseBio",
    data() {
        return {
            allProvs: null,               // List of providers already saved for patient
            txtMsg: "",
            txtPhone:"",  
                         // Fax number of chosen physician
        }
    },
    props: {

      nurseLList:Object,
      
    },
    beforeMount()
    {
      this.checkScreensize();
    },
    computed: {
        ...mapGetters("login", {
            allData: "getAllData",
        }),
        patient: function () {
            return this.allData.patient;
        },
        manager: function () {
            return this.allData.manager
        },
       
    },
    methods:{
     checkScreensize()
    {
      
        let height = $(window).height;
        let width = $(window).width;
        //alert($(window).width);
        if($(window).width >760 && $(window).width <=1024)
        {
          alert("Tableet");
        }
     
    },
    showEmailModule(event,nurseLList,pid)
    {
      console.log(event.target.id +" "+"ShowEmailModule");
      console.log(event.target);
      console.log(pid);
      $("#emailcanvas"+pid).css("display","block");
      let subject ="You have a message from"+" "+nurseLList.firstname+" "+nurseLList.lastname+", Please login into the Erriff Health Portal to view message.";
            $("#provemailsubject"+pid).val(subject);
            let message="Dr. "+nurseLList.firstname+",please login to view your message from the Erriff Health Portal.";
            $("#provid-emailmsg"+pid).val(message);
            console.log($(".emailcanvas").attr("class"));
           
            $("#emailcanvas"+pid).css("display","block");
            //now lets bind the providers email address to the email input field 
            console.log(nurseLList.email);
            $("#providetomail"+pid).val(nurseLList.email);
      console.log($("#emailcanvas"+pid).attr("id"));
    },
    closeOption(event)
    {
      
      $(event.target).closest(".m-option").css("display","none");
    },
    closeDOption(event)
    {
      
      $(event.target).closest(".d-option").css("display","none");
    },
      async CallProvider(nurseLList) {
            if (!this.manager.phone1 && !this.manager.phone2) {
                alert("You have no phone number associated with your account. Please visit your profile page and set one.")
            }
            else {
                let content = {
                    "Twilio": {
                        "API_Meth": "SendPhoneCall",
                        "from": this.manager.phone1 ? this.manager.phone1 : this.manager.phone2,
                        "callnumber": nurseLList.tel ? nurseLList.cell: nurseLList.tel
                    }
                }
                await axios
                    .post(CURR_API + "/tswebhook.php", content, {
                        headers: { "Content-Type": "application/json;" },
                    })
                    .then((res) => {
                        console.log(res);
                        if (res.data.status != "") {
                            alert("Connecting call...")
                        }
                        else {
                            alert("Error connecting call.")
                        }
                    });
            }
        },
      async CallProviderCell(event,id)
      {
        console.log(event.target.id);
        console.log(window.innerWidth);
        console.log("ID"+" "+id);
        if(window.innerWidth <768)
        {
          $("#d-option"+id).css("display","none");
          $("#m-option"+id).css("display","flex");
        }
        if(window.innerWidth >=1024)
        {
          $("#d-option"+id).css("display","flex");
          $("#m-option"+id).css("display","none");
        }
        
      },
      showTextProv(event,prvphone,pid,provid) {
            this.txtPhone = prvphone;
            console.log(this.txtPhone);
           console.log(event.target.id);
           // $("#d-option" + pid).css("display", "flex");
            $("#send-text-modal-"+pid).css("display","flex");
            $("#modaltext"+pid).val(prvphone);
            $("#d-option"+provid).css("display","none");
        },
       async VerifyNurse(licensenumber)
        {
           $("#desktopLicense"+licensenumber).removeAttr("href");
           $("#desktopLicense"+licensenumber).css("background-color","#000000");
           $("#desktopLicense"+licensenumber).css("color","#ffffff");
          let licnum = $("#desktopLicense"+licensenumber).html();
           $("#desktopLicense"+licensenumber).html("...verifying");
           
            //grab info needed to verify
            let content = {
                "NursyInfo": {
                    "API_Meth": "LookupNursesInfo",
                    "rnlicense": licnum, //$("#desktopLicense"+licensenumber).html(),
                    "jurisdiction":  $("#state"+licensenumber).html(),
                    "ltype": $("#ltype"+licensenumber).html() ,

                }
            }
            await axios
                .post(CURR_API + "/tswebhook.php",content,{
                    headers: { "Content-Type": "application/json;" },
                })
                .then((res) => {
                    console.log(res);
                    $("#desktopLicense"+licensenumber).attr("href","#verify");
                    $("#desktopLicense"+licensenumber).css("background-color","#ffffff");
                    $("#desktopLicense"+licensenumber).css("color","#0d6efd");
                    $("#desktopLicense"+licensenumber).html(licensenumber);
                    // Read through the shared classifier. This block used to
                    // reference a bare, undefined NurseLookupDisciplines - a
                    // ReferenceError on every non-active licence - and to walk
                    // the discipline array with the licence loop's counter.
                    const verdict = classifyLookup(res?.data);
                    if (verdict.kind === UNAVAILABLE) {
                        alert("We could not reach the license verification service just now. Please try again in a few minutes.");
                        return;
                    }
                    if (verdict.kind !== FOUND) {
                        alert(verdict.message || "No result found for that license number.");
                        return;
                    }
                    const wantedType = $("#ltype"+licensenumber).html();
                    verdict.licences
                        .filter((licence) => licence && licence.LicenseType == wantedType)
                        .forEach((licence) => {
                            if (isLicenceInGoodStanding(licence)) {
                                alert("License Active, no action needed.");
                                $("#vstatus2"+licensenumber).css("display","block");
                                $("#vstatus"+licensenumber).css("display","none");
                            } else if (isLicenceReinstated(licence)) {
                                $(".status-active").attr("class","col-sm-12 col-md-12 col-lg-12 status-good");
                                alert("License Reinstated");
                            } else {
                                alert("License Not Active, please take action as needed.");
                                $("#vstatus"+licensenumber).css("display","block");
                                $("#vstatus2"+licensenumber).css("display","none");
                            }
                        });
                }, (error) => {
                    // axios rejects a refused request - keyon's Nursys gate
                    // answers a lapsed session with 401 - and with no arm here
                    // the link stayed on "...verifying" and nothing was said.
                    $("#desktopLicense"+licensenumber).attr("href","#verify");
                    $("#desktopLicense"+licensenumber).css("background-color","#ffffff");
                    $("#desktopLicense"+licensenumber).css("color","#0d6efd");
                    $("#desktopLicense"+licensenumber).html(licensenumber);
                    alert(lookupFailureMessage(error));
                });
        },
        CancelUpdateNurse(event,licensnum){
            //close the div section
            event.preventDefault();
            $("#nurseform"+licensnum).css("display","none");
            $("#nursecard"+licensnum).slideDown("slow");
        },
        async UpdateNurse(event,license){
            event.preventDefault();
            $("#updatenursebtn").attr("disabled","disabled");
            let content = {
                // ManageNurseLList (two Ls) matched no dispatch branch in keyon,
                // so this form has never saved anything.
                ManageNurseList: {
                    API_Meth: "Add_Nurse",
                    ncsid: $("#nurseform"+license).find("#nrnsbid").val(),
                    // The licence's own state; the card's State (the address) only for a
                    // licence with none on file (utils/nurseCardJurisdiction).
                    jurisdiction: enrolmentJurisdiction(this.nurseLList, $("#nurseform" + license).find("#nrstate").val()),
                    subactioncode:"A",//required
                    licensnum: $("#nurseform"+license).find("#nrlicense").val(),
                    ltype: $("#nurseform"+license).find("#nursetype").val(),
                    email: $("#nurseform"+license).find("#nurseemail").val(),
                    primephone: $("#nurseform"+license).find("#primephone").val(),
                    secondaryphone: $("#nurseform"+license).find("#secphone").val(),
                    address1: $("#nurseform"+license).find("#nraddress").val(),//req
                    address2: "",
                    city: $("#nurseform"+license).find("#nrcity").val(),//req
                    state: $("#nurseform"+license).find("#nrstate").val(),//req
                    zip: $("#nurseform"+license).find("#nrzip").val(),//req
                    lastfourssn: $("#nurseform"+license).find("#nrsocial").val(),//req
                    bdayear: $("#nurseform"+license).find("#nrdob").val(),//req
                    hospitalpracsetting: "21",//req
                    hostpracsettingother:"",
                    notficationenabled: "N" ,//req
                    reminderenabled: "N",//req
                    locationlist: "",
                    recid: "" ,
                    accountnumber: $("#nurseform"+license).find("#nraccount").val(),
                    firstname:$("#nurseform"+license).find("nursefname").val(),
                    lastname:$("#nurseform"+license).find("#nurselname").val(),
                   
                   
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                $("#updatenursebtn").removeAttr("disabled");
                let jdata = res;
                console.log(jdata);
                if(jdata.data.status=="Nurse Added")
                {
                    alert("Nurse" +" "+$("#nursefname").val() +" "+$("#nurselname").val()+" Successfully Updated");
                    //now close SMS Canvas
                   
                   
                        //lets now add them to our internal database 
                                
                       this.UpdateInternalNurse(license);

                    
                   
                }
                else if(jdata.data.errors)
                {
                    alert("Issue");
                    alert(jdata.errors.ErrorMessage);
                }
            });
        },
        async UpdateInternalNurse(license){
            let content = {
                ManageNurseList: {
                    API_Meth: "InternalUpdateNurse",
                    // The person the card shows, and their account type: PATCH /users
                    // needs the one, and an aide's number is her HHA certificate, not a
                    // state licence (accountBridge.internalUpdateNurse).
                    providerid: (this.nurseLList || {}).providerid || (this.nurseLList || {}).unique_ID,
                    nurseType: (this.nurseLList || {}).caregivetype || (this.nurseLList || {}).account_type,
                    ncsid: $("#nurseform"+license).find("#nrnsbid").val(),
                    // The licence's own state, never the card's State field, which is the
                    // address (utils/nurseCardJurisdiction).
                    jurisdiction: licenceJurisdiction(this.nurseLList),
                    subactioncode:"A",//required
                    licensnum: $("#nurseform"+license).find("#nrlicense").val(),
                    ltype: $("#nurseform"+license).find("#nursetype").val(),
                    email: $("#nurseform"+license).find("#nurseemail").val(),
                    primearyphone:$("#nurseform"+license).find("#primephone").val(),
                    secondaryphone: $("#nurseform"+license).find("#secphone").val(),
                    address1: $("#nurseform"+license).find("#nraddress").val(),//req
                    address2: "",
                    city: $("#nurseform"+license).find("#nrcity").val(),//req
                    state: $("#nurseform"+license).find("#nrstate").val(),//req
                    zip: $("#nurseform"+license).find("#nrzip").val(),//req
                    lastfourssn: $("#nurseform"+license).find("#nrsocial").val(),//req
                    bdayear: $("#nurseform"+license).find("#nrdob").val(),//req
                    hospitalpracsetting: "21",//req
                    hostpracsettingother:"",
                    notficationenabled: "Y" ,//req
                    reminderenabled: "Y",//req
                    locationlist: "",
                    recid: "" ,
                    accountnumber: $("#nurseform"+license).find("#nraccount").val(),
                    firstname:$("#nurseform"+license).find("#nursefname").val(),
                    lastname:$("#nurseform"+license).find("#nurselname").val(),
                   
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                if(res.data.message=="Updated")
                {
                    alert("Nurse infomration updated successfully!");
                    //now close SMS Canvas
                   
                   
                   
                }
                else
                {
                    alert(res.message);
                    console.log("Nurses not added successfully");
                }
            });
        },
      async callProvider(nurseLList) {
            if (!this.manager.phone1 && !this.manager.phone2) {
                alert("You have no phone number associated with your account. Please visit your profile page and set one.")
            }
            else {
                let content = {
                    "Twilio": {
                        "API_Meth": "SendPhoneCall",
                        "from": this.manager.phone1 ? this.manager.phone1 : this.manager.phone2,
                        "callnumber": provider.tel
                    }
                }
                await axios
                    .post(CURR_API + "/tswebhook.php", content, {
                        headers: { "Content-Type": "application/json;" },
                    })
                    .then((res) => {
                        console.log(res);
                        if (res.data.status != "") {
                            alert("Connecting call...")
                        }
                        else {
                            alert("Error connecting call.")
                        }
                    });
            }
        },
        EmitNurseCard()
        {
          this.$emit('custom-event');
        },
    },
    
  }
 
</script>

<style scoped lang="scss">
#nurseform28146329A{
    width:635px;
    height:auto;
    display:flex;
    flex-direction:column;
}
.status-active{
    display:none;
    background-color:#70a50d;
    color:#ffffff;
    font-size:17px;
}
.status-nonactive{
    display:none;
    background-color:#f12f4f;
    color:#ffffff;
    font-size:17px;
}
.nurse-edit{
    display:none;
}
.btn-sec{
    display:flex;

}
#nurseform28146329A input[type="text"]{
    margin-bottom:10px;
}
#nurseform28146329A input[type=date]
{
    margin-bottom:10x;
}
#nurseform28146329A input[type=phone]
{
    margin-bottom:10px;
}
  $color-font: darken(#58595b, 10%);
  table {
    text-align: left;
    width: 100%;
  }

  tr {
    font-size: 0.95em;
  }

  .table-container {
    padding: 1em 2em 1.5em;
    border-bottom: 1px solid lightgray;
  }

  .provider__avatar {
    width: 100px;
  }

  .provider__title {
    font-size: 1.5em;
  }

  .provider__info {
    color: $color-font;
    line-height: 1.8em;
  }

  .icon {
    margin-right: 0.5em;
  }

  .capitalize {
    text-transform: capitalize;
  }
  .nurse-edit{
    /*display:none;*/
  }
  @media only screen and (min-width:1024px)
  {
   .table-container .m-flex{
      display:block;
    }
    .m-align{
      text-align:left;
    }
    .table-container .m-option{
      display:none;
    }
    .x-close{
      height:21px;
    }
    .option-item h4{
      font-size: 16px;
      text-align: center;
    }
    .d-option{
      display:flex;
    }
    .m-option{
      display: none;
    }
    .slabel{
      margin-right:15px;
    }
    .icon .mobileTel{
      display:none;
    }
    .icon .desktopTel{
      display:flex;
    }
  }
  @media screen and (min-width: 360px)
  {
    .m-flex{
      display:flex;
      flex-direction:column;
    }
    .m-align{
      text-align: center;
    }
    .m-option{
      display:flex;
      flex-direction:column;
    }
    .d-option{
      display:none;
    }
    .option-container{
      border-color: #0335;
      border-style: solid;
      border-width: 1px;
      padding: 15px 20px;
    }
    .option-item:last-child{
      margin-top:12px;
    }
    .option-item h4{
      font-size:22px;
    }
    .x-close{
      margin-bottom:0px;
      width:100%;
      height:42px;
      display: flex;
      flex-direction: row-reverse;
    }
    .m-itemclose{
      font-size:20px;
      color:#000000;
    }
    .d-option{
      display: none;
    flex-direction: column;
    position: relative;
    /*left: 580px;
    z-index: 4000000;
    background-color: #fff;
    top: 300px;*/
    
    left: -180px;
    z-index: 4000000;
    background-color: #fff;
    top: 0px;
    width: 300px;
    }
    .m-option{
      display:none;
    }
    .icon.mobileTel{
      display:flex;
    }
    .icon.desktopTel{
      display:none;
    }
  }
</style>